import * as prioritizationIndices from './prioritizationIndices';
import * as logisticnIndices from './logisticIndices';

const reducers = {
  ...prioritizationIndices,
  ...logisticnIndices,
};

export default reducers;
